

/// <reference path="TimeRangePresetConfiguration.ts" />

// Generated class TakeAwayTimeRangePresetConfiguration_ManagedObject

class TakeAwayTimeRangePresetConfiguration_ManagedObject extends TimeRangePresetConfiguration
{
}
